import {
  POLICY_RENEWAL_STATUS,
  Policy,
  PolicyRenewalStatus,
} from '@lockton-apps/shared/interfaces';

import { isoDifferenceInDaysToNow } from './date.helpers';

function determineStatus(daysRemaining: number): PolicyRenewalStatus {
  if (daysRemaining > 150) {
    return POLICY_RENEWAL_STATUS.Active;
  } else if (daysRemaining <= 150 && daysRemaining > 30) {
    return POLICY_RENEWAL_STATUS.RenewalUpcoming;
  } else if (daysRemaining <= 30 && daysRemaining > 0) {
    return POLICY_RENEWAL_STATUS.RenewalImminent;
  } else {
    return POLICY_RENEWAL_STATUS.Expired;
  }
}

export function addPolicyStatus(policy: Policy): Policy {
  return {
    ...policy,
    renewalStatus: determineStatus(isoDifferenceInDaysToNow(policy.expiryDate)),
  };
}
